import { Link } from "react-router-dom";
import { navSections, siteName } from "@/mocks/mangaData";

const linkMap: Record<string, string> = {
  topic: "/topic",
  community: "/community",
  rank: "/rank",
  booklist: "/booklist",
  about: "/about",
};

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {siteName}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              漫画e站官方页，汇总评论区里的读者吐槽与热门话题，整理评分排行和推荐书单，
              帮你快速找到同好交流的聚集地，看看大家都在追什么、避雷什么。
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="#"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-bilibili-line text-base"></i>
              </a>
              <a
                href="#"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a
                href="#"
                aria-label="知乎"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                <i className="ri-zhihu-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">内容栏目</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              {navSections.map((s) => (
                <li key={s.key}>
                  <Link to={linkMap[s.key]} className="transition-colors hover:text-primary-700">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">关于站点</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-700">
                  网站定位
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-700">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/topic" className="transition-colors hover:text-primary-700">
                  参与讨论
                </Link>
              </li>
              <li>
                <a href="mailto:hello@manhuaezhan.example" className="transition-colors hover:text-primary-700">
                  联系与合作
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © 2026 {siteName} 同好交流聚集地 · 本站内容由读者共创整理，仅供交流参考
          </p>
          <p className="text-xs text-foreground-500">
            推荐在移动端与桌面端均可正常浏览
          </p>
        </div>
      </div>
    </footer>
  );
}